// eslint-disable-next-line no-underscore-dangle
window.__TRANSCEPTA_BUILD_KEY__ = window.__TRANSCEPTA_BUILD_KEY__ ?? process.env.REACT_APP_BUILD_KEY;

export {};
